import { open } from "fs"
import { IOpModifier, OpTouchEnum } from "./IOp"
import { allowedNodeEnvironmentFlags } from "process"

export interface IPoso {
    poso: number | undefined
    ido: number | undefined
    touch: OpTouchEnum
}


export type OpTouchCallback =  (op:any, touch: OpTouchEnum, prop:string | undefined, prop_old_value: any, prop_new_value:any, user:string|undefined, filter:string|undefined  ) => void


export class OpArray {

    static mul: number = 1


    static ensure_ido(arr: IPoso[], o: IPoso) {
        if (o.ido) return;
        const last_ido = this.get_last_ido(arr)
        o.ido = last_ido+1;
    }

    static update(arr:IPoso[], o: IPoso) {
        o.touch = OpTouchEnum.UPDATE
        this.ensure_ido(arr, o)
    }

    static get_i_by_poso(arr: IPoso[], poso: number | undefined, offset:number): number {
        const l = arr.length
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].poso == poso) {
                const p = i+offset
                if (p<0) return -1
                if (p>l-1) return -1
                return i
            }
        }
        return -1
    }


    static get_by_poso(arr: IPoso[], poso: number | undefined, offset:number): IPoso| undefined {
        const l = arr.length
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].poso == poso) {
                const p = i+offset
                if (p<0) return undefined
                if (p>l-1) return undefined
                return arr[p]
            }
        }
        return undefined
    }


    static insert_after(arr: IPoso[], modified: IOpModifier[], o_prev: IPoso | undefined, o_new: IPoso) {

        if (arr.length == 0 || !o_prev) {
            o_new.poso = 1 * this.mul
            o_new.touch = OpTouchEnum.CREATE
            this.ensure_ido(arr, o_new)
            modified.push({op:o_new, touch:OpTouchEnum.CREATE, prop:'poso', prop_old_value:undefined, prop_new_value:o_new.poso,filter:undefined, user:undefined, status:OpTouchEnum.NO_ACTION })
            arr.push(o_new)
            return
        }

        if (!o_prev || !o_prev.poso) return;

        for (let i = 0; i < arr.length; i++) {
            const o = arr[i]
            if (o.poso == o_prev.poso) {
                if (i == arr.length - 1) {
                    // insert after last 
                    //o_new.poso = (i+2) * this.mul
                    o_new.poso = o_prev.poso + this.mul
                    console.log("************************** poso",o_prev.poso, o_new.poso )
                    o_new.touch = OpTouchEnum.CREATE
                    this.ensure_ido(arr, o_new)
                    arr.push(o_new)
                    modified.push({op:o_new, touch:OpTouchEnum.CREATE, prop:'poso', prop_old_value:undefined, prop_new_value:o_new.poso,filter:undefined, user:undefined, status:OpTouchEnum.NO_ACTION })
                    return;

                } else {
                    this.handle_small_gap(arr,modified,i, i+1)

                    const poso_prev: number | undefined = arr[i].poso
                    if (poso_prev === undefined) return;

                    const poso_next: number | undefined = arr[i + 1].poso
                    if (poso_next === undefined) return;
                    o_new.poso = (poso_next + poso_prev) / 2
                    o_new.touch = OpTouchEnum.CREATE
                    this.ensure_ido(arr, o_new)
                    arr.push(o_new)
                    modified.push({op:o_new, touch:OpTouchEnum.CREATE, prop:'poso', prop_old_value:undefined, prop_new_value:o_new.poso,filter:undefined, user:undefined, status:OpTouchEnum.NO_ACTION })
                    return
                }
            }
        }
        return;
    }


    static move_before(arr: IPoso[], modified: IOpModifier[], o_prev: IPoso, o: IPoso) {

        if (arr.length == 0) return;
        if (!o_prev.poso) return;
        const poso_before = o.poso

        this.sort(arr)

        for (let i = 0; i < arr.length; i++) {

            if (arr[i].poso == o_prev.poso) {
                if (i==0) {
                    this.handle_small_gap(arr,modified,0, 1)
                    o.poso = o_prev.poso/2
                    o.touch = OpTouchEnum.UPDATE
                    modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:'poso', prop_old_value:poso_before, prop_new_value:o.poso,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
                    return
                } else {
                    this.handle_small_gap(arr,modified,i-1, i)

                    const poso_prev: number | undefined = arr[i-1].poso
                    if (poso_prev === undefined) return;

                    const poso_next: number | undefined = arr[i].poso
                    if (poso_next === undefined) return;

                    o.poso = (poso_next + poso_prev) / 2
                    o.touch = OpTouchEnum.UPDATE
                    this.ensure_ido(arr, o)
                    modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:'poso', prop_old_value:poso_before, prop_new_value:o.poso,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
                }
            }
        }
        return;
    }


    static move_after(arr: IPoso[], modified: IOpModifier[], o_next: IPoso, o: IPoso) {

        if (arr.length == 0) return;
        if (!o_next.poso) return;
        const l = arr.length
        this.sort(arr)
        const poso_before = o.poso

        for (let i = 0; i < arr.length; i++) {

            if (arr[i].poso == o_next.poso) {
                if (i==l-1) {
                    o.poso = o_next.poso+ (1*this.mul)
                    o.touch = OpTouchEnum.UPDATE
                    modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:'poso', prop_old_value:poso_before, prop_new_value:o.poso,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
                    return;
                } else {

                    this.handle_small_gap(arr,modified,i, i+1)
                    const poso_prev: number | undefined = arr[i].poso
                    console.log("poso_prev",poso_prev)
                    if (poso_prev === undefined) return;

                    const poso_next: number | undefined = arr[i+1].poso
                    if (poso_next === undefined) return;

                    o.poso = (poso_next + poso_prev) / 2
                    o.touch = OpTouchEnum.UPDATE
                    this.ensure_ido(arr, o)
                    modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:'poso', prop_old_value:poso_before, prop_new_value:o.poso,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
                }
            }
        }
        return;
    }


    static remove(arr: IPoso[], modified: IOpModifier[], op: IPoso) {
        const poso_before = op.poso
        const l = arr.length
        let p:number=-1
        for (let i = 0; i < arr.length; i++) {
            if (op.poso && arr[i].poso == op.poso) 
            {
                p=i
            }
        }
        if (p<0) return;

        op.touch = OpTouchEnum.DELETE
        if (p < l - 1) {
            arr.splice(p, 1)
        }
        else if (p == l - 1) {
            arr.pop()
        }
        modified.push({op:op, touch:OpTouchEnum.DELETE, prop:'poso', prop_old_value:poso_before, prop_new_value:undefined,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
        

    }

    static get_last_ido(arr: IPoso[]) {
        let last:number=0
        for (let i=0;i<arr.length;i++) {
                let curr = arr[i].ido
                if (!curr) curr =0
                if (curr > last) { last=curr }
        } 
        return last
    }

    static get_last_poso(arr: IPoso[]) {
        let last:number=0
        for (let i=0;i<arr.length;i++) {
                let curr = arr[i].poso
                if (!curr) curr =0
                if (curr > last) { last=curr }
        } 
        return last
    }


    static handle_undefined(a:number | undefined):number {
        if (!a) return 0
        return a
    }

    static sort(arr: IPoso[]) {
        arr.sort( (a,b) => { return this.handle_undefined(a.poso) - this.handle_undefined(b.poso)})
    }
    

    static handle_small_gap(arr: IPoso[], modified: IOpModifier[],i1:number, i2:number) {
        if (this.handle_undefined(arr[i2].poso) - this.handle_undefined(arr[i1].poso)<0.000000000001) {
            console.log("R E P O S")
            for (let i = 0; i < arr.length; i++) {
                const poso_before = arr[i].poso
                arr[i].poso = (i+1)*this.mul
                arr[i].touch = OpTouchEnum.DELETE
                const o=arr[i]
                modified.push({op:o, touch:OpTouchEnum.UPDATE, prop:'poso', prop_old_value:poso_before, prop_new_value:o.poso,filter:undefined, user:undefined,status:OpTouchEnum.NO_ACTION })
            }
        }
       
    }

}




